import type { ScreenFactory } from "../../taskScreenRegistry";

import { createCreditCardScreens } from "./credit_cards";
import { createMortgageScreens } from "./mortgage";
import { createOtherLoansScreens } from "./other_loans";
import { createOtherDebtsScreens } from "./other_debts";

export const debtsLoansTasks: Record<string, ScreenFactory> = {
  credit_cards: createCreditCardScreens,
  mortgage: createMortgageScreens,
  other_loans: createOtherLoansScreens,
  other_debts: createOtherDebtsScreens,
};
